import { render, staticRenderFns } from "./fire-policy-detail-info.vue?vue&type=template&id=63c3e4c0&scoped=true&"
import script from "./fire-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./fire-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./fire-policy-detail-info.vue?vue&type=style&index=0&id=63c3e4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c3e4c0",
  null
  
)

export default component.exports